import clsx from "clsx";

export const PackCoverImage: React.FC<{
  image: string;
  color: string | null;
  className?: string;
}> = ({ image, color, className }) => {
  return (
    <>
      <img
        loading="lazy"
        draggable={false}
        src={image}
        alt="pack cover image"
        className={clsx("absolute inset-0 size-full object-cover", className)}
      />
      {color && (
        <div
          className="absolute inset-0 bg-gradient-to-t from-[--color]"
          style={
            {
              "--color": color,
            } as React.CSSProperties
          }
        />
      )}
    </>
  );
};
